declare namespace $ {

	type $mol_view__sub_shm_tests_player_1 = $mol_type_enforce<
		ReturnType< $shm_tests_player['workspace_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_tests_player_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type __shm_tests_player_3 = $mol_type_enforce<
		Parameters< $shm_tests_player['playing'] >[0]
		,
		Parameters< ReturnType< $shm_tests_player['Video'] >['playing'] >[0]
	>
	type __shm_tests_player_4 = $mol_type_enforce<
		Parameters< $shm_tests_player['time'] >[0]
		,
		Parameters< ReturnType< $shm_tests_player['Video'] >['time'] >[0]
	>
	type $mol_view__sub_shm_tests_player_5 = $mol_type_enforce<
		ReturnType< $shm_tests_player['current_benchmark_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_tests_player_6 = $mol_type_enforce<
		ReturnType< $shm_tests_player['current_media_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_icon__checked_shm_tests_player_7 = $mol_type_enforce<
		ReturnType< $shm_tests_player['play_step_active'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__title_shm_tests_player_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['title'] >
	>
	type $mol_check_icon__hint_shm_tests_player_9 = $mol_type_enforce<
		ReturnType< $shm_tests_player['play_step_title'] >
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__enabled_shm_tests_player_10 = $mol_type_enforce<
		ReturnType< $shm_tests_player['play_step_enabled'] >
		,
		ReturnType< $mol_check_icon['enabled'] >
	>
	type $mol_check_icon__click_shm_tests_player_11 = $mol_type_enforce<
		ReturnType< $shm_tests_player['play_step'] >
		,
		ReturnType< $mol_check_icon['click'] >
	>
	type $mol_check_icon__Icon_shm_tests_player_12 = $mol_type_enforce<
		ReturnType< $shm_tests_player['Play_step_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_button_minor__title_shm_tests_player_13 = $mol_type_enforce<
		ReturnType< $shm_tests_player['play_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_tests_player_14 = $mol_type_enforce<
		ReturnType< $shm_tests_player['play_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_tests_player_15 = $mol_type_enforce<
		ReturnType< $shm_tests_player['speed_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_tests_player_16 = $mol_type_enforce<
		ReturnType< $shm_tests_player['speed_cycle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_tests_player_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_video_player__uri_shm_tests_player_18 = $mol_type_enforce<
		ReturnType< $shm_tests_player['video_uri'] >
		,
		ReturnType< $mol_video_player['uri'] >
	>
	type $mol_video_player__controls_shm_tests_player_19 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['controls'] >
	>
	type $mol_video_player__autoplay_shm_tests_player_20 = $mol_type_enforce<
		ReturnType< $shm_tests_player['video_autoplay'] >
		,
		ReturnType< $mol_video_player['autoplay'] >
	>
	type $mol_video_player__muted_shm_tests_player_21 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['muted'] >
	>
	type $mol_video_player__inline_shm_tests_player_22 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['inline'] >
	>
	type $mol_video_player__loop_shm_tests_player_23 = $mol_type_enforce<
		ReturnType< $shm_tests_player['video_loop'] >
		,
		ReturnType< $mol_video_player['loop'] >
	>
	type $mol_video_player__event_shm_tests_player_24 = $mol_type_enforce<
		({ 
			timeupdate( next?: ReturnType< $shm_tests_player['step_timeupdate'] > ): ReturnType< $shm_tests_player['step_timeupdate'] >,
			ended( next?: ReturnType< $shm_tests_player['video_ended'] > ): ReturnType< $shm_tests_player['video_ended'] >,
		})  & ReturnType< $mol_video_player['event'] >
		,
		ReturnType< $mol_video_player['event'] >
	>
	type $mol_view__sub_shm_tests_player_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_tests_player_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_tests_benchmark_table__results_shm_tests_player_27 = $mol_type_enforce<
		ReturnType< $shm_tests_player['comparison_results'] >
		,
		ReturnType< $shm_tests_benchmark_table['results'] >
	>
	type $shm_tests_benchmark_table__step_title_shm_tests_player_28 = $mol_type_enforce<
		ReturnType< $shm_tests_player['current_step_title'] >
		,
		ReturnType< $shm_tests_benchmark_table['step_title'] >
	>
	type $shm_tests_benchmark_table__step_index_shm_tests_player_29 = $mol_type_enforce<
		ReturnType< $shm_tests_player['current_step_index'] >
		,
		ReturnType< $shm_tests_benchmark_table['step_index'] >
	>
	type $shm_tests_visual__comparison_shm_tests_player_30 = $mol_type_enforce<
		ReturnType< $shm_tests_player['current_visual'] >
		,
		ReturnType< $shm_tests_visual['comparison'] >
	>
	type $shm_tests_visual__manifest_uri_shm_tests_player_31 = $mol_type_enforce<
		ReturnType< $shm_tests_player['manifest_uri'] >
		,
		ReturnType< $shm_tests_visual['manifest_uri'] >
	>
	type $mol_image__uri_shm_tests_player_32 = $mol_type_enforce<
		ReturnType< $shm_tests_player['current_screenshot_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__title_shm_tests_player_33 = $mol_type_enforce<
		ReturnType< $shm_tests_player['current_screenshot_title'] >
		,
		ReturnType< $mol_image['title'] >
	>
	type $mol_paragraph__title_shm_tests_player_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $shm_tests_player extends $mol_view {
		workspace_rows( ): readonly($mol_view)[]
		Main( ): $mol_view
		Workspace( ): $mol_view
		video_uri( ): string
		playing( next?: ReturnType< ReturnType< $shm_tests_player['Video'] >['playing'] > ): ReturnType< ReturnType< $shm_tests_player['Video'] >['playing'] >
		time( next?: ReturnType< ReturnType< $shm_tests_player['Video'] >['time'] > ): ReturnType< ReturnType< $shm_tests_player['Video'] >['time'] >
		media_duration( ): ReturnType< ReturnType< $shm_tests_player['Video'] >['duration'] >
		video_autoplay( ): boolean
		video_loop( ): boolean
		step_timeupdate( next?: any ): any
		video_ended( next?: any ): any
		current_benchmark_content( ): readonly($mol_view)[]
		Current_benchmarks( ): $mol_view
		current_media_rows( ): readonly($mol_view)[]
		Current_media( ): $mol_view
		play_step_active( next?: boolean ): boolean
		play_step_title( ): string
		play_step_enabled( ): boolean
		play_step( next?: any ): any
		Play_step_icon( ): $mol_icon_loop
		Play_step( ): $mol_check_icon
		play_title( ): string
		play_toggle( next?: any ): any
		Play( ): $mol_button_minor
		speed_title( ): string
		speed_cycle( next?: any ): any
		Speed( ): $mol_button_minor
		time_title( ): string
		Time( ): $mol_view
		current_step_title( ): string
		current_screenshot_uri( id: any): string
		current_screenshot_title( id: any): string
		result( ): any
		comparison_results( ): readonly(any)[]
		manifest_uri( ): string
		speed( next?: number ): number
		play_step_index( next?: number ): number
		segment_index( next?: number ): number
		current_step_index( ): number
		current_visual( id: any): any
		current_title( ): string
		current_step_range( ): string
		sub( ): readonly(any)[]
		Video( ): $mol_video_player
		Current( ): $mol_view
		Controls( ): $mol_view
		Current_benchmark_table( ): $shm_tests_benchmark_table
		Current_visual( id: any): $shm_tests_visual
		Current_screenshot( id: any): $mol_image
		Current_screenshot_empty( ): $mol_paragraph
	}
	
}

//# sourceMappingURL=player.view.tree.d.ts.map